import React from 'react';
import DishComponent from './DishComponent';
import { maskMoney } from '../../masks';
import FormsySimpleInput from '../form/FormsySimpleInput';

class DishRecipeEdit extends React.Component {
  render() {
    const { dish } = this.props;
    return (
      <div className="dish__recipe--edit">
        <div className="cms__section">
          <div className="cms__bar cms__section-head">
            <div className="cms__bar-left">
              <h3 className="h3">Recipe</h3>
            </div>
          </div>
          {this.mapComponents(dish.components)}

          <div className="cms__section-body dish-component">
            <div
              className="btn btn--hollow-blue btn--full-width"
              onClick={this.props.addComponent}
            >
              {' '}
              + Add Component
            </div>
          </div>
          <div className="form__row row--space-between">
            <div className="form__row-item form__row-item--half">
              <p className="simple-input__label">Serves Min:</p>
              <FormsySimpleInput
                type="number"
                name="serves_min"
                placeholder=""
                value={dish.serves_min || ''}
                onChange={(e) => { this.props.updateDish({serves_min: e.target.value}) }}
                autoComplete="off"
              />
            </div>
            <div className="form__row-item form__row-item--half">
              <p className="simple-input__label">Serves Max:</p>
              <FormsySimpleInput
                type="number"
                name="serves_max"
                placeholder=""
                value={dish.serves_max || ''}
                onChange={(e) => { this.props.updateDish({serves_max: e.target.value}) }}
                autoComplete="off"
              />
            </div>
          </div>

          <div className="row recipe-price row--space-between">
            <div className="row-item">
              <p className="recipe-price__label">
                Estimated Grocery Cost:{' '}
                <span className="recipe-price__label--value">
                  {maskMoney(dish.price_cents || '')}
                </span>
              </p>
            </div>
            <div className="row-item">
              <div
                className="a--blue"
                onClick={() => this.props.openModal('grocery-calc')}
              >
                Grocery Calculator
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  mapComponents = recipe => {
    const {
      openModal,
      updateComponent,
      deleteComponent,
      updateSubcomponent,
      deleteSubcomponent,
      updateIngredient,
      deleteIngredient
    } = this.props;

    const componentProps = {
      openModal,
      updateComponent,
      deleteComponent,
      updateSubcomponent,
      deleteSubcomponent,
      updateIngredient,
      deleteIngredient
    };

    if (recipe)
      return recipe.map((component, key) => (
        <DishComponent
          key={key}
          index={key}
          component={component}
          {...componentProps}
        />
      ));
  };
}

export default DishRecipeEdit;



// WEBPACK FOOTER //
// ./src/components/dish/DishRecipeEdit.js